import { Formik } from "formik";
import { FC, SetStateAction, createContext, useEffect, useState } from "react";
import FormNhapKho from "./components/FormNhapKho";
import * as Yup from "yup";
import { getListWarehouse } from "../utils/ServicesUtils";
import { TypeNhapKho } from "./models/NhapKhoModel";

export interface PhanHeNhapKhoContextProps {
    dsNhapKho: any;
    setDsNhapKho: SetStateAction<any>;
    detailPhieuNhap: any;
    setDetailPhieuNhap: SetStateAction<any>;

}

const initialContext = {
    dsNhapKho: [],
    setDsNhapKho: () => { },
    detailPhieuNhap: [],
    setDetailPhieuNhap: () => { },
}

export const PhanHeNhapKhoContext = createContext<PhanHeNhapKhoContextProps>(initialContext)
interface Props {
    warehouseId: number;
    className?: any;
    typeKho?: any;
    warehouseInfo?: { id: number; code: string; name: string }; // truyền sẵn kho, không cần lấy danh sách kho
    typeOptions?: TypeNhapKho[]; // giới hạn loại nhập hiển thị
}
export const PhanHeNhapKho = (props: Props) => {
    const { warehouseId, typeKho, className, warehouseInfo, typeOptions } = props;
    const [dsNhapKho, setDsNhapKho] = useState([]);
    const [detailPhieuNhap, setDetailPhieuNhap] = useState({});
    const [lstWarehouse, setLstWarehouse] = useState<any>(() => warehouseInfo
        ? {
            [warehouseInfo.id]: {
                mateWhId: warehouseInfo.id,
                mateWhName: warehouseInfo.name,
                mateWh: warehouseInfo.code,
            }
        }
        : {});

    let validationSchema = Yup.object({});
    const handleFormSubmit = (values: any) => { }

    const updateData = async () => {
        try {
            const data = await getListWarehouse();
            let newLstData: any = {};
            data.forEach((item: any) => {
                newLstData[item.id] = {
                    mateWhId: item.id,
                    mateWhName: item.name,
                    mateWh: item.code,
                };
            });
            setLstWarehouse(newLstData);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        if (warehouseInfo) return;
        updateData();
    }, []);

    return (
        <Formik<any>
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
        >
            <PhanHeNhapKhoContext.Provider
                value={{
                    dsNhapKho: dsNhapKho,
                    setDsNhapKho: setDsNhapKho,
                    detailPhieuNhap,
                    setDetailPhieuNhap,
                }}
            >
                <div className="bg-white">

                    <div className="flex-1 flex flex-column">
                        <div className="py-1">
                            <FormNhapKho
                                className={className}
                                LST_WAREHOUSE={lstWarehouse}
                                warehouseId={warehouseId}
                                typeKho={typeKho}
                                typeOptions={typeOptions}
                            />
                        </div>
                    </div>


                </div>

            </PhanHeNhapKhoContext.Provider>
        </Formik>

    )
}

export default PhanHeNhapKho;
